const Yup = require('yup');

export const trimText = (text: string): string => {
    return text.trim();
};

// eslint-disable-next-line
export const allowEmptyString = (value: any): any => (value === '' ? '' : value);

export const emptySubmit = (): void => {};

export const onSubmit = (): void => {
    return;
};

export function isBlobURL(value: string) {
    const REGEXP_BLOB_URL = /^blob:.+\/[\w-]{36,}(?:#.+)?$/;
    return REGEXP_BLOB_URL.test(value);
}

export const mapOrder = <T, K extends keyof T>(array: Array<T>, order: Array<T[K]>, key: K): Array<T> => {
    array.sort( function( a: T, b: T ): number {
        const A = a[key];
        const B = b[key];
        if (order.indexOf(A) > order.indexOf(B)) {
            return 1;
        } else {
            return -1;
        }
    });
    return array;
};

export const closest = (value: number, array: Array<number>) => {
    let current = array[0];
    let diff = Math.abs(value - current);

    for (let index = 0; index < array.length; index++) {
        const newdiff = Math.abs(value - array[index]);

        if (array[index] > value) {
            break;
        }

        if (newdiff < diff) {
            diff = newdiff;
            current = array[index];
        }
    }

    return current;
};

export const validateURL = (value: string) =>
    value.trim() && Yup.string().url().isValidSync(value) ? true : false;

export const mapDropdownItemToCommonSwithcerOption = (item: {text: string, value: string}) => {
    return {
        value: item.value,
        label: item.text,
    };
};
